import React from "react";
import { Button, Flex, Box } from "@chakra-ui/react";

// The search API returns hasMore instead of a total, so paging is previous/next only.
const Pagination = ({ page, hasMore, onPageChange }) => {
  if (page <= 1 && !hasMore) return null;

  return (
    <Flex justify="center" align="center" p="4">
      <Button
        aria-label="Previous page"
        onClick={() => onPageChange(Math.max(page - 1, 1))}
        isDisabled={page <= 1}
        mx="2"
      >
        {"<"}
      </Button>
      <Box mx={4}>{`Page ${page}`}</Box>
      <Button
        aria-label="Next page"
        onClick={() => onPageChange(page + 1)}
        isDisabled={!hasMore}
        mx="2"
      >
        {">"}
      </Button>
    </Flex>
  );
};

export default Pagination;
